import Loader from '@/components/Loader';
import { useFilter } from '@/hooks/filter';
import { useTheme } from '@/hooks/theme';
import { Box, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { DropdownProps } from '@components/Filters/interfaces';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

const ChakraRadioFilter: React.FC<any> = ({
  title,
  onSelect,
  initialSelected,
  onPaginate,
  setCurrentPage,
  currentPage,
  options,
  changePageOn,
  hasNextPage,
}) => {
  const stackRef = useRef(null);
  const { loading } = useFilter();
  const { colors } = useTheme();
  const [selected, setSelected] = useState<string>(() => {
    if (initialSelected) {
      const currentOption = options.find(
        (option) => option?.value === initialSelected,
      );
      return currentOption?.key || initialSelected;
    }
    return '';
  });

  const handleSelect = useCallback((value: Option) => {
    setSelected(() => value.name);
  }, []);

  const handleScroll = async () => {
    const stackElement: any = stackRef.current;
    if (
      stackElement?.scrollTop + stackElement?.clientHeight ===
      stackElement?.scrollHeight
    ) {
      onPaginate(currentPage + 1);
      setCurrentPage((prevPage: number) => prevPage + 1);
    }
  };

  useEffect(() => {
    if (!selected) {
      onSelect(null);
    }
    if (selected) {
      onSelect(selected);
    }
  }, [selected]);

  const optionsWithSelectState = useMemo(() => {
    return options.map(
      ({ key: id, value: name }: { key: string; value: any }) => {
        return { ...{ id, name } };
      },
    );
  }, [options]);

  if (loading) {
    return (
      <Box
        display="flex"
        height="240px"
        justifyContent="center"
        alignItems="center"
      >
        <Loader loadColor={colors.primary} />
      </Box>
    );
  }
  const checkScroll = !changePageOn && hasNextPage && handleScroll

  return (
    <>
      <RadioGroup defaultValue={selected}>
        <Stack
          ref={stackRef}
          spacing="0.5"
          direction="column"
          paddingX="2"
          maxHeight="240px"
          overflowY="scroll"
          height="240px"
          onScroll={checkScroll ? checkScroll : undefined}
        >
          {optionsWithSelectState?.map((opt: any) => {
            return (
              <Radio
                key={opt?.id}
                size="lg"
                paddingY="1"
                onChange={(e) =>
                  handleSelect({ id: opt.id, name: opt.name })
                }
                value={opt.name}
                _checked={{
                  bg: colors.primary,
                  color: 'white',
                  borderColor: colors.primary,
                }}
                _hover={{
                  bgColor: 'gray.100',
                }}
                _focus={{
                  boxShadow: `0 0 0 2 ${colors.primary}`,
                }}
              >
                {opt?.id}
              </Radio>
            );
          })}
        </Stack>
      </RadioGroup>
    </>
  );
};

export default ChakraRadioFilter;
